// istanbul ignore file — composition shell; logic lives in hooks, slices, and child modules.

import { I18n } from '@calendly/i18n'
import { PageHeader } from '@calendly/ui/components/page-header'
import { useSelector } from 'react-redux'

import { LoadingWrapper } from 'components/core/loading_state'
import { PageContainer } from 'components/page_elements'
import { isDataLoadingSelector, Workflows } from 'features/account_settings'
import { useIsSettingsModalLayout } from 'features/settings_modal/layout_context'

export const WorkflowsPage = () => {
  const isLoading = useSelector(isDataLoadingSelector)
  const inSettingsModal = useIsSettingsModalLayout()

  return (
    <>
      {!inSettingsModal && (
        <PageHeader
          eyebrow={I18n.t('publisher.personal_settings.navigation.account_details')}
          title={I18n.t('publisher.account_settings.communication_settings.title')}
        />
      )}
      <PageContainer>
        <LoadingWrapper isLoading={isLoading}>
          <Workflows />
        </LoadingWrapper>
      </PageContainer>
    </>
  )
}
